<div
  class="keypad-panel"
  [class.flexible]="flexible"
>
  <keypad
    [displays]="[keyPadType]"
    [returnInitialValue]="true"
    [inputValue]="keypadInputValue"
    (value)="onKeyPadInput($event)"
  >
    @if (isClosable) {
      <xea-icon-button
        icon="icon-close"
        class="button-close"
        [e2eAttr]="e2e.KEY_PAD_ICON_CLOSE"
        (click)="onClose()"
      >
      </xea-icon-button>
    }
    <div class="keypad-title">
      <p>{{ title | translate }}</p>
    </div>
  </keypad>
  @if (keyPadButtons?.length) {
    <div class="keypad-buttons">
      @for (button of keyPadButtons; track $index) {
        <button
          class="x_btn x_bordered"
          [class.x_primary]="button.primary"
          [ngClass]="button.class"
          [attr.e2e-attr]="button.e2eAttr"
          [disabled]="button.disabled"
          (click)="button.onClick?.()"
        >
          {{ button.text | translate }}
        </button>
      }
    </div>
  }
</div>
